
import Layout from "../components/Layout";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "react-multi-select-component";
import { Row } from "react-bootstrap";
import { toast } from 'react-toastify'

const HeadSetup = () => {
    const [start] = useState(0);
    const [empIdpList, setEmpIdpList] = useState([]);
    const { user } = useSelector((state) => state["auth"]);
    const [filters, setFilters] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const navigate = useNavigate()

    const [factoryData, setFactoryData] = useState([])
    const [departmentData, setDepartmentData] = useState([])
    const [designationData, setDesignationData] = useState([])
    const [quarterNames, setQuarterNames] = useState([]);
    const [monthNames, setMonthNames] = useState([]);
    const [selected, setSelected] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState([]);
    const [selectedUnitForHOD, setSelectedUnitForHOD] = useState([]);
    const [selectedUnitForHr, setSelectedUnitForHr] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [getFilterData, setGetFilterData] = useState([]);
    const [userInformation, setUserInformation] = useState([]);
    const [headWiseEmployeeInformation, setHeadWiseEmployeeInformation] = useState([]);
    const [departmentNames, setDepartmentNames] = useState([]);
    const [divisionNames, setDivisionNames] = useState([]);
    const [unitNames, setUnitNames] = useState([]);
    const [hodRegisterId, setHodRegisterId] = useState([]);
    const [divisionHeadRegisterId, setDivisionHeadRegisterId] = useState([]);
    const [hrRegisterId, setHrRegisterId] = useState([]);
    const [employeeInformation, setEmployeeInformation] = useState({
        addedBy: "",
        registerID: 0,
        employeeCode: "",
        employeeName: "",
        department: "",
        designation: "",
        division: "",
        company: "",
        hodRegisterID:"",
        divisionHeadRegisterID:"",
        hrRegisterID:""
    })

    const successNotify = (message) => toast.info(message);
    const errorNotify = (message) => toast.error(message);

    useEffect(() => {
        initFilters();
        getEmployeeIDPList(user.registerID)
        GetEmployeeFilterData()
        GetAllMonthList();
        GetSubmittedQuarterNames(user.registerID);
        GetUserInformation(user.registerID);
        GetAllDepartment();
        GetAllDivision();
        GetAllUnit();
        GetHeadWiseEmployeeInformation(0);
    }, [])


    const GetUserInformation = (id) => {
        setIsLoading(true);
        axios.get(BASE_URL + `/api/register/GetAllRegisterUsers/${id}`)
            .then(response => {
                //(response.data);
                setUserInformation(response.data);
                setIsLoading(false);
            })
            .catch(e => {
                console.log(e);
                setIsLoading(false);
            })
    }

    const GetHeadWiseEmployeeInformation = (id) => {
        setIsLoading(true);
        axios.get(BASE_URL + `/api/utility/GetHeadWiseEmployeeInfo/${id}`)
            .then(response => {
                //console.log(response.data);
                setHeadWiseEmployeeInformation(response.data);
                setIsLoading(false);
            })
            .catch(e => {
                console.log(e);
                setIsLoading(false);
            })
    }

    const GetEmployeeFilterData = () => {
        axios.get(BASE_URL + "/api/report/GetFilterFactoryData")
            .then(response => {
                setFactoryData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDepartmentData")
            .then(response => {
                setDepartmentData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDesignationData")
            .then(response => {
                //console.log(response.data);
                setDesignationData(response.data)
            })
            .catch(console.error)
    }

    const GetSubmittedQuarterNames = (id) => {
        axios
            .post(BASE_URL + `/api/dashboard/GetSubmittedQuarterNames/${id}`)
            .then((response) => {
                setQuarterNames(
                    response.data.map((record) => {
                        return {
                            value: record.quarterID,
                            label: record.quarterName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const GetAllMonthList = () => {
        axios.post(BASE_URL + `/api/utility/GetAllMonth`)
            .then((response) => {
                //console.log(response);
                setMonthNames(
                    response.data.map((record) => {
                        return {
                            value: record.monthID,
                            label: record.monthName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };


    const getEmployeeIDPList = (id) => {
        axios.get(BASE_URL + "/api/idp/GetIDPEmployeeListAdmin/" + id)
            .then(response => {
                setEmpIdpList(response.data)
            })
            .catch(e => console.log(e))
    }

    const getEmployeeIDPListBySearch = (id) => {
        axios.get(BASE_URL + "/api/idp/GetIDPEmployeeListAdmin/" + id)
            .then(response => {
                setEmpIdpList(response.data)
            })
            .catch(e => console.log(e))
    }


    const _actionBody = (empIdp) => (<>
        <button type="button" style={{ cursor: "pointer", padding: "2px 5px 2px 5px", fontSize: "10pt" }} className="btn btn-outline-primary" onClick={() => {
            navigate({
                pathname: "/IDPDetails",
                search: createSearchParams({
                    employeeId: empIdp.registerID
                }).toString()
            });
        }}>Create IDP</button>
    </>)
    const _actionIDPBody = (empIdp) => (<>
        {console.log(btoa("category=textile&user=user1"))}
        {console.log(empIdp)}
        <div class="btn-group">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                Select
            </button>
            <ul class="dropdown-menu" style={{ minWidth: "11rem" }}>
                <li><a style={{ fontWeight: "600" }} className="dropdown-item" href="#"
                    onClick={() => {
                        //console.log("Hello");
                        //console.log(empIdp);
                        var selectedQuarters = selected.map(o => o.value)
                        //window.open("http://localhost:13805/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterID=" + user.quarterID));    
                        //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterID=" + user.quarterID));                        
                        //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterIDList=" + selectedQuarters.toString()));                        
                        window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr=" + btoa("RegisterID=" + empIdp.registerID + "&QuarterIDList=" + empIdp.quarterID.toString()));
                    }}><i class="bi bi-person-bounding-box"></i> IDP Report</a>
                </li>
                {/* <li><a style={{fontWeight:"600"}} className="dropdown-item" href="#" 
                onClick={()=>{
                    navigate({
                        pathname: "/IDPDetails",
                        search: createSearchParams({
                            employeeId: btoa(empIdp.registerID)
                        }).toString()
                    });
                    }}><i class="bi bi-pencil-fill"></i> Create IDP</a>
                </li> */}
                <li><a style={{ fontWeight: "600" }} className="dropdown-item" href="#"
                    onClick={() => {
                        navigate({
                            pathname: "/EvaluationReport",
                            search: createSearchParams({
                                employeeId: btoa(empIdp.registerID)
                            }).toString()
                        });
                    }}><i class="bi bi-person-lines-fill"></i> Evaluation Report</a>
                </li>
            </ul>
        </div>
    </>)
    const _actionReportBody = (empIdp) => (<>
        <button type="button" style={{ cursor: "pointer", padding: "2px 5px 2px 5px", fontSize: "10pt" }} className="btn btn-outline-secondary" onClick={() => {
            navigate({
                pathname: "/EvaluationReport",
                search: createSearchParams({
                    employeeId: empIdp.registerID
                }).toString()
            });
        }}>Evaluation Report</button>
    </>)

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters1(_filters);
        setGlobalFilterValue1(value);
    }


    const initFilters = () => {
        setFilters({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
        });
        setGlobalFilterValue('');
    }

    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
        });
        setGlobalFilterValue1('');
    }
    const clearFilter = () => {
        initFilters();
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                        onClick={clearFilter} />
                    <span className="p-input-icon-left"> <i className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                            placeholder="Keyword Search" />
                    </span>
                </div>
            </div>
        </div>
    );

    const header1 = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                        onClick={clearFilter1} />
                    <span className="p-input-icon-left"> <i className="pi pi-search" />
                        <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                            placeholder="Keyword Search" />
                    </span>
                </div>
            </div>
        </div>
    );

    const empCodeBody = emp => {
        return <span className={"text-success"}
            style={{ cursor: "pointer" }}
            onClick={() => {
                LoadSupervisorInformation(emp.registerID);
            }}>
            {emp.employeeName}
        </span>
    }

    const LoadSupervisorInformation = (id) => {
        axios.get(BASE_URL + `/api/utility/GetUserInfoForHeadSetup/${id}`)
            .then(response => {                
                if (response.data.length > 0) {                    
                    setEmployeeInformation({
                        addedBy: user.registerID,
                        registerID: response.data[0].registerID,
                        employeeCode: response.data[0].employeeCode,
                        employeeName: response.data[0].employeeName,
                        department: response.data[0].department,
                        designation: response.data[0].designation,
                        division: response.data[0].division,
                        company: response.data[0].company,
                        hodRegisterID:response.data[0].hodRegisterID,
                        divisionHeadRegisterID:response.data[0].divisionHeadRegisterID,
                        hrRegisterID:response.data[0].hrRegisterID
                    });
                    console.log(employeeInformation);
                }
                else {
                    setEmployeeInformation([]);
                }
                //console.log(response.data);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const GetAllDepartment = () => {
        axios
            .get(BASE_URL + `/api/utility/GetAllDepartment`)
            .then((response) => {
                //console.log(response);
                setDepartmentNames(
                    response.data.map((record) => {
                        return {
                            value: record.departmentId,
                            label: record.departmentName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const GetAllDivision = () => {
        axios
            .get(BASE_URL + `/api/utility/GetAllDivision`)
            .then((response) => {
                //console.log(response);
                setDivisionNames(
                    response.data.map((record) => {
                        return {
                            value: record.divisionId,
                            label: record.divisionName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const GetAllUnit = () => {
        axios
            .get(BASE_URL + `/api/utility/GetAllUnit`)
            .then((response) => {
                //console.log(response);
                setUnitNames(
                    response.data.map((record) => {
                        return {
                            value: record.unitId,
                            label: record.unitName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const saveHOD = () => {
        const _dbModel = { registerId: employeeInformation.registerID,hodRegisterId:hodRegisterId, addedBy: user.registerID.toString() }
        //console.log(JSON.stringify(_dbModel));
        axios.post(BASE_URL + "/api/utility/SaveHOD/", JSON.stringify(_dbModel))
            .then(response => {
                if (response.status === 200) {
                    successNotify("Data saved successfully.");
                    getEmployeeIDPList(user.registerID);
                    // window.location.reload();
                }
            })
            .catch(e => console.log(e))
    }

    const saveDivisionHead = () => {
        const _dbModel = { registerId: employeeInformation.registerID,divisionHeadRegisterId:divisionHeadRegisterId, addedBy: user.registerID.toString() }
        axios.post(BASE_URL + "/api/utility/SaveDivisionHead/", JSON.stringify(_dbModel))
            .then(response => {
                if (response.status === 200) {
                    successNotify("Data saved successfully.");
                    getEmployeeIDPList(user.registerID);
                }
            })
            .catch(e => console.log(e))
    }

    const saveHR = () => {
        const _dbModel = { registerId: employeeInformation.registerID, hrRegisterId:hrRegisterId, addedBy: user.registerID.toString() }
        axios.post(BASE_URL + "/api/utility/SaveHR/", JSON.stringify(_dbModel))
            .then(response => {
                if (response.status === 200) {
                    successNotify("Data saved successfully.");
                    getEmployeeIDPList(user.registerID);
                }
            })
            .catch(e => console.log(e))
    }

    const onHodRegisterIdChange = (event) => {
        event.preventDefault();
        setHodRegisterId(event.target.value );
    }

    const onDivisionHeadRegisterIdChange = (event) => {
        setDivisionHeadRegisterId( event.target.value );
    }

    const onHrRegisterIdChange = (event) => {
        //console.log(event.target.value);
        setHrRegisterId(event.target.value);
    }

    return (<Layout>

        <div className="card mt-2">
            <div className="card-header">
                <h6><i className="bi bi-people-fill"></i> Head Setup</h6>

            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-8">
                        <DataTable value={userInformation}
                            header={header}
                            resizableColumns
                            showGridlines
                            dataKey="registerID"
                            filters={filters}
                            filterDisplay="menu"
                            globalFilterFields={['registerID', 'employeeCode', 'employeeName', 'department', 'designation', 'supervisorName']}
                            paginator rows={10} first={start}
                            paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                            <Column field='registerID' header="Reg. ID" sortable />
                            <Column field='employeeCode' header="Code" sortable className="text-center" />
                            <Column field='employeeName' header="Employee Name" sortable body={empCodeBody} />
                            <Column field='supervisorName' header="Supervisor Name" sortable />
                            <Column field='department' header="Department" sortable />
                            <Column field='designation' header="Designation" sortable />
                        </DataTable>
                    </div>
                    <div className="col-4">
                        <div className="card">
                            <div className="card-header">
                                <div className="card-title">
                                    <b><i class="bi bi-person-lines-fill"></i> Employee Info</b>
                                </div>
                            </div>
                            <div className="card-body">

                                <div className="row g-3 mb-1 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label htmlFor="employeeName" className="col-form-label">
                                            <b>Emp Code:</b>
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <input
                                            id="employeeCode"
                                            className="form-control"
                                            disabled={true}
                                            value={employeeInformation.employeeCode}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row g-3 mb-1 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label htmlFor="employeeName" className="col-form-label">
                                            <b>Emp Name:</b>
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <input
                                            id="employeeName"
                                            className="form-control"
                                            disabled={true}
                                            value={employeeInformation.employeeName}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row g-3 mb-1 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label htmlFor="employeeName" className="col-form-label">
                                            <b>Designation:</b>
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <input
                                            id="designation"
                                            className="form-control"
                                            disabled={true}
                                            value={employeeInformation.designation}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row g-3 mb-1 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label htmlFor="department" className="col-form-label">
                                            <b>Department:</b>
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <input
                                            id="department"
                                            className="form-control"
                                            disabled={true}
                                            value={employeeInformation.department}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row g-3 mb-1 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label htmlFor="employeeName" className="col-form-label">
                                            <b>Division:</b>
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <input
                                            id="designation"
                                            className="form-control"
                                            disabled={true}
                                            value={employeeInformation.division}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row g-3 mb-1 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label htmlFor="employeeName" className="col-form-label">
                                            <b>Company:</b>
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <input
                                            id="designation"
                                            className="form-control"
                                            disabled={true}
                                            value={employeeInformation.company}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <b><i class="bi bi-person-lines-fill"></i> HOD Setup</b>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter HOD Register ID.."
                                        onChange={onHodRegisterIdChange}
                                        autoFocus="autoFocus"
                                        defaultValue={employeeInformation.hodRegisterID}
                                        //value={employeeInformation.hodRegisterID}
                                        name="txtHODRegisterId"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <button className="btn btn-success" onClick={() => saveHOD()}><i class="bi bi-eraser"></i> Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <b><i class="bi bi-person-lines-fill"></i> Unit Head Setup</b>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Unit Head Register ID.."
                                        onChange={onDivisionHeadRegisterIdChange}
                                        autoFocus="autoFocus"
                                        defaultValue={employeeInformation.divisionHeadRegisterID}
                                        name="txtDivisionHeadRegisterId"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <button className="btn btn-success" onClick={() => saveDivisionHead()}><i class="bi bi-eraser"></i> Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />

                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <b><i class="bi bi-person-lines-fill"></i> HR Person Setup</b>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter HR Person Register ID.."
                                        onChange={onHrRegisterIdChange}
                                        autoFocus="autoFocus"
                                        defaultValue={employeeInformation.hrRegisterID}
                                        name="txtHRRegisterId"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <button className="btn btn-success" onClick={() => saveHR()}><i class="bi bi-eraser"></i> Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <b><i class="bi bi-person-lines-fill"></i> Head wise employee Info</b>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <DataTable value={headWiseEmployeeInformation}
                                        header={header1}
                                        resizableColumns
                                        showGridlines
                                        dataKey="registerID"
                                        filters={filters1}
                                        filterDisplay="menu"
                                        globalFilterFields={['registerID', 'employeeCode', 'employeeName', 'department', 'designation', 'supervisorName']}
                                        paginator rows={10} first={start}
                                        paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                                        <Column field='registerID' header="Reg. ID" sortable className="text-center" />
                                        <Column field='employeeCode' header="Code" sortable className="text-center" />
                                        <Column field='employeeName' header="Employee Name" sortable />
                                        <Column field='designation' header="Designation" />
                                        <Column field='department' header="Department" sortable />
                                        <Column field='division' header="Division" sortable />
                                        <Column field='unitName' header="User Factory" sortable />
                                        <Column field='supervisorRegisterId' header="Supervisor Id" sortable />
                                        <Column field='supervisorName' header="Supervisor Name" sortable />
                                        <Column field='hodRegisterID' header="HOD Id" sortable />
                                        <Column field='hodName' header="HOD Name" sortable />
                                        <Column field='divisionHeadRegisterID' header="Unit Head Id" sortable />
                                        <Column field='divisionHeadName' header="Unit Head Name" sortable />
                                        <Column field='hrRegisterID' header="HR Id" sortable />
                                        <Column field='hrName' header="HR Name" sortable />
                                    </DataTable>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </Layout>)
}


export default HeadSetup